import { H3Medium as H3MediumStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the H3Medium typography style.
 */
export default function H3Medium({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(H3MediumStyle, sx)} />;
}
